import type { FaireProductEntity } from "../../entity_types/product";

export const p_du135bia5y: FaireProductEntity = {
  token: "p_du135bia5y",
  type: "product",
  name: "White Little Notes® Ceramic Holder",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/93fdc9347b06b0e24bf3ebec7083cd6bd6a681cbce2c23fb60032b6c7e789d46.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6837911f077cb052e9943bd80223708aa652a98dfed2774186101a05b1b781eb.webp",
  ],
  priceDollars: 13,
  description:
    "Give your Little Notes® a cozy home on your desk or counter with this gorgeous ceramic cube. Substantial in weight and glazed in a matte finish, this accessory is the perfect gift for all Little Notes lovers!\n\nPerfectly fits two boxes of Little Notes® or 150 loose Little Notes®. Please note, Little Notes® must be purchased separately!",
  tags: [],
  msrpDollars: 26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:12.034Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
